if(!customElements.get('partners-dropdown')) {
   /**
   *  @class
   *  @function PartnersDropdown
   */
   class PartnersDropdown extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.partners-dropdown__button');
      this.content = this.querySelector('.partners-dropdown__content');

      this.content.style.setProperty('--max-height', (this.content.scrollHeight + 50) + 'px');
      this.button.addEventListener('click', this.onClick.bind(this));
    }
    onClick() {
      this.getAttribute('open') !== null ? this.removeAttribute('open') : this.setAttribute('open', '')
    }

   }

   customElements.define('partners-dropdown', PartnersDropdown);
}